import React, { useEffect } from "react";
import { useGetVideosQuery } from "../../../features/videos/videosAPI";
import ErrorMessage from "../../ui/ErrorMessage";
import { useDispatch } from "react-redux";
import { selectVideo } from "../../../features/coursePlayer/coursePlayerSlice";
import { useGetAssignmentOfVideoQuery } from "../../../features/assignments/assignmentsAPI";
function CourseVideos() {
  const { data: videos, isLoading, isError, isSuccess } = useGetVideosQuery();

  const dispatch = useDispatch();
  function handleVideoSelect(video) {
    dispatch(selectVideo(video));
    //save last played video on Local Storage for persistency effect as Database is immutable
    localStorage.setItem("lastPlayed", JSON.stringify(video));
  }

  //if logged in for the first time, play first video of the course
  useEffect(() => {
    if (!localStorage.getItem("lastPlayed")) {
      if (videos?.length > 0) {
        const firstVideo = videos[0];
        dispatch(selectVideo(firstVideo));
        localStorage.setItem("lastPlayed", JSON.stringify(firstVideo));
      }
    } else {
      const lastPlayedVideo = JSON.parse(localStorage.getItem("lastPlayed"));
      dispatch(selectVideo(lastPlayedVideo));
    }
  }, [videos, dispatch]);

  let content = null;
  if (isLoading) content = "Loading...";
  else if (isError) content = <ErrorMessage />;
  else if (isSuccess && videos?.length === 0) content = "No Video yet!";
  else if (isSuccess && videos?.length > 0)
    content = videos?.map((video) => (
      <div
        key={video?.id}
        className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2 py-3"
        onClick={() => {
          handleVideoSelect(video);
        }}
      >
        {/* <!-- Thumbnail --> */}
        <svg
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
          />
        </svg>
        {/* <!-- Description --> */}
        <div clas="flex flex-col w-full">
          {/* <a href="#"> */}
          <p className="text-slate-50 text-sm font-medium">{video?.title}</p>
          {/* </a> */}
          <div>
            <span className="text-gray-400 text-xs mt-1">
              {video?.duration} Mins
            </span>
            <span className="text-gray-400 text-xs mt-1"> | </span>
            <span className="text-gray-400 text-xs mt-1">
              {video?.views} views
            </span>
          </div>
        </div>
      </div>
    ));

  return (
    <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
      {content}
    </div>
  );
}

export default CourseVideos;
